"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signatureMsApi = exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _endpoints = require("./endpoints");
var _functions = require("../@functions");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef Certificate
 * @type {typeof certificateModel}
 */

var signatureMsApi = {
  certificates: {
    /**
     * @param {{
     *     uid?: string;
     *     url?: string;
     *     file?: File;
     * }} certificate
     * @param {string} password
     * @param {any=} storage
     */
    validate: function () {
      var _validate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(certificate, password, storage) {
        var url, ref, certBuffer, path;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = '';
              ref = undefined;
              if (!certificate.file) {
                _context.next = 13;
                break;
              }
              _context.next = 5;
              return certificate.file.arrayBuffer();
            case 5:
              certBuffer = _context.sent;
              path = "certificates/".concat((0, _functions.customSizeUid)(), "-").concat(new Date(), "-").concat(certificate.file.name);
              ref = storage.ref(path);
              _context.next = 10;
              return ref.put(certBuffer);
            case 10:
              _context.next = 12;
              return ref.getDownloadURL();
            case 12:
              url = _context.sent;
            case 13:
              _context.prev = 13;
              _context.next = 16;
              return _endpoints.signatureMicroservice.post('/certificates/validate', {
                certificate: _objectSpread(_objectSpread({}, certificate), {}, {
                  url: url
                }),
                password: password
              });
            case 16:
              if (!ref) {
                _context.next = 19;
                break;
              }
              _context.next = 19;
              return ref["delete"]();
            case 19:
              return _context.abrupt("return", true);
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](13);
              return _context.abrupt("return", false);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[13, 22]]);
      }));
      function validate(_x, _x2, _x3) {
        return _validate.apply(this, arguments);
      }
      return validate;
    }(),
    /**
     * @param {{ [key: string]: string }} queries
     * @param {number=} limit
     * @returns {Promise<Certificate[]>}
     */
    list: function () {
      var _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(queries, limit) {
        var json, urlQueries, _yield$signatureMicro, _yield$signatureMicro2, dataList;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              json = _objectSpread({}, queries);
              if (limit) {
                json.limit = String(limit);
              }
              urlQueries = (0, _functions.jsonToUrlQueries)(json);
              _context2.next = 5;
              return _endpoints.signatureMicroservice.get("/certificates/list/?".concat(urlQueries));
            case 5:
              _yield$signatureMicro = _context2.sent;
              _yield$signatureMicro2 = _yield$signatureMicro.data;
              dataList = _yield$signatureMicro2 === void 0 ? [] : _yield$signatureMicro2;
              return _context2.abrupt("return", dataList);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function list(_x4, _x5) {
        return _list.apply(this, arguments);
      }
      return list;
    }(),
    /**
     * @param {File} certificateFile
     * @param {any} storage
     * @param {{
     *     password?: string;
     *     metadata?: { [key: string]: any };
     * }=} params
     */
    upload: function () {
      var _upload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(certificateFile, storage) {
        var params,
          password,
          _params$metadata,
          metadata,
          certBuffer,
          path,
          ref,
          url,
          _yield$signatureMicro3,
          data,
          _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              params = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              password = params.password, _params$metadata = params.metadata, metadata = _params$metadata === void 0 ? {} : _params$metadata;
              _context3.next = 4;
              return certificateFile.arrayBuffer();
            case 4:
              certBuffer = _context3.sent;
              path = "certificates/".concat((0, _functions.customSizeUid)(), "-").concat(new Date(), "-").concat(certificateFile.name);
              ref = storage.ref(path);
              _context3.next = 9;
              return ref.put(certBuffer);
            case 9:
              _context3.next = 11;
              return ref.getDownloadURL();
            case 11:
              url = _context3.sent;
              _context3.next = 14;
              return _endpoints.signatureMicroservice.post('/certificates/save', {
                certificate: {
                  name: certificateFile.name,
                  size: certificateFile.size,
                  type: certificateFile.type,
                  url: url,
                  metadata: metadata
                },
                password: password
              });
            case 14:
              _yield$signatureMicro3 = _context3.sent;
              data = _yield$signatureMicro3.data;
              return _context3.abrupt("return", data);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function upload(_x6, _x7) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }(),
    /**
     * @param {string} certificateUid
     * @param {any} updates
     */
    update: function () {
      var _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(certificateUid, updates) {
        var _yield$signatureMicro4, data;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _endpoints.signatureMicroservice.post("/certificates/".concat(certificateUid, "/update"), {
                updates: updates
              });
            case 2:
              _yield$signatureMicro4 = _context4.sent;
              data = _yield$signatureMicro4.data;
              return _context4.abrupt("return", data);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function update(_x8, _x9) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }
};
exports.signatureMsApi = signatureMsApi;
var _default = signatureMsApi;
exports["default"] = _default;